import React from 'react';
import styles from './index.module.scss';

// componente options
function OptionSelect({data, ...props}){

    // propriedades importantes
    let { innerProps, innerRef, isFocused } = props;

    // retorna componente
    return <div tabIndex='-1' ref={innerRef} {...innerProps} className={[styles.option, isFocused && styles.focado].join(' ')}>
        <div className={styles.dadosUsuario}>
            { data.foto &&
                <img src={`${process.env.REACT_APP_URL_ARQUIVOS}/arquivos/fotos/${data.foto}`} className='rounded' />
            }
            <div>
                <p><b>{data.id}</b> - {data.nome}</p>
                {/* <p>{data.profissao}</p> */}
            </div>
        </div>
    </div>
}

// opção
export default OptionSelect;